import { useContext } from "react";
import { Authentication } from "../Authentication/context/AuthenticationProvider";
const useAuthentication = () => {
  const context = useContext(Authentication);
  if (!context) {
    throw new Error(
      "useAuthentication must be used within an AuthenticationProvider",
    );
  }
  return context;
};

export default useAuthentication;
